import { useState, useEffect } from 'react';
import { api } from '../api';

export default function Dashboard() {
  const [stats, setStats] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.getStats()
      .then(setStats)
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const statCards = [
    { label: 'Total Students',     value: stats.totalStudents ?? '—', sub: '↑ 18 from last year',   color: 'blue',   icon: 'fas fa-user-graduate' },
    { label: 'Teachers',           value: stats.totalTeachers ?? '—', sub: '4 subjects unassigned', color: 'green',  icon: 'fas fa-chalkboard-teacher' },
    { label: 'Fees Collected',     value: stats.feesCollected ?? '₹8.4L', sub: '₹1.2L pending',    color: 'orange', icon: 'fas fa-rupee-sign' },
    { label: "Today's Attendance", value: stats.attendanceRate ?? '92%', sub: '34 absent',           color: 'purple', icon: 'fas fa-calendar-check' },
    { label: 'Salary This Month',  value: stats.salaryTotal ?? '₹6.8L', sub: 'Disbursed on 1st',   color: 'red',    icon: 'fas fa-wallet' },
    { label: 'Classes',            value: stats.totalClasses ?? '—',   sub: '1–10 + 2 sections',   color: 'teal',   icon: 'fas fa-school' },
  ];

  const timeline = [
    { icon: 'fas fa-rupee-sign', title: 'Fee collected — Ravi Kumar (Class 8A) ₹12,500',      meta: 'Today, 10:32 AM' },
    { icon: 'fas fa-user-plus',  title: 'New student admitted — Priya Sharma, Class 5B',       meta: 'Today, 9:14 AM' },
    { icon: 'fas fa-calendar-check', title: 'Attendance marked — Class 10A (48/50 present)',   meta: 'Yesterday, 8:45 AM' },
    { icon: 'fas fa-chart-bar',  title: 'Marks uploaded — Unit Test 2, Class 7B Science',      meta: 'Yesterday, 2:00 PM' },
    { icon: 'fas fa-wallet',     title: 'Salary disbursed — 32 staff members',                 meta: '01 May, 9:00 AM' },
  ];

  return (
    <div>
      {loading && <div className="loading-msg">Loading dashboard…</div>}

      <div className="stats-grid">
        {statCards.map(c => (
          <div className="stat-card" key={c.label}>
            <div className={`stat-icon ${c.color}`}><i className={c.icon}></i></div>
            <div>
              <div className="stat-label">{c.label}</div>
              <div className="stat-value">{c.value}</div>
              <div className="stat-sub">{c.sub}</div>
            </div>
          </div>
        ))}
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: '2fr 1fr', gap: 20 }}>
        {/* Recent Activity */}
        <div className="card">
          <div className="card-header">
            <div>
              <div className="card-title">Recent Activity</div>
              <div className="card-subtitle">Last 7 days</div>
            </div>
          </div>
          <div className="card-body">
            <div className="timeline">
              {timeline.map((item, i) => (
                <div className="tl-item" key={i}>
                  <div className="tl-dot"><i className={item.icon}></i></div>
                  <div className="tl-content">
                    <div className="tl-title">{item.title}</div>
                    <div className="tl-meta">{item.meta}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Right column */}
        <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          {/* Fee Defaulters */}
          <div className="card">
            <div className="card-header"><div className="card-title">Fee Defaulters</div></div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><div style={{ fontSize: 13, fontWeight: 600 }}>Arjun Reddy</div><div style={{ fontSize: 11, color: '#a0aec0' }}>Class 6A</div></div>
                <span className="badge badge-red">₹8,000</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><div style={{ fontSize: 13, fontWeight: 600 }}>Meena Das</div><div style={{ fontSize: 11, color: '#a0aec0' }}>Class 9B</div></div>
                <span className="badge badge-red">₹15,000</span>
              </div>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div><div style={{ fontSize: 13, fontWeight: 600 }}>Kiran Patel</div><div style={{ fontSize: 11, color: '#a0aec0' }}>Class 3A</div></div>
                <span className="badge badge-orange">₹4,500</span>
              </div>
              <button className="btn btn-outline btn-sm" style={{ width: '100%' }}>View All 12 Defaulters</button>
            </div>
          </div>

          {/* Upcoming Holidays */}
          <div className="card">
            <div className="card-header"><div className="card-title">Upcoming Holidays</div></div>
            <div className="card-body" style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <div style={{ background: '#fff5f5', color: '#c53030', borderRadius: 8, padding: '4px 8px', textAlign: 'center', minWidth: 40 }}>
                  <div style={{ fontSize: 16, fontWeight: 800 }}>15</div>
                  <div style={{ fontSize: 9 }}>MAY</div>
                </div>
                <div><div style={{ fontSize: 13, fontWeight: 600 }}>Buddha Purnima</div><div style={{ fontSize: 11, color: '#a0aec0' }}>National Holiday</div></div>
              </div>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
                <div style={{ background: '#fff5f5', color: '#c53030', borderRadius: 8, padding: '4px 8px', textAlign: 'center', minWidth: 40 }}>
                  <div style={{ fontSize: 16, fontWeight: 800 }}>01</div>
                  <div style={{ fontSize: 9 }}>JUN</div>
                </div>
                <div><div style={{ fontSize: 13, fontWeight: 600 }}>Summer Break Begins</div><div style={{ fontSize: 11, color: '#a0aec0' }}>45-day break</div></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
